<!-- start page title -->
<div class="row h-40px">
  <div class="col-12">
    <div class="page-title-box d-flex align-items-center justify-content-between">
      <h4 class="mb-0">{{ title }}</h4>

      <!--<div class="page-title-right">
        <ol class="breadcrumb m-0">
          <ng-container *ngFor="let item of breadcrumbItems">
            <li class="breadcrumb-item" [ngClass]="{'active': item.active === true}">{{ item.label }}
            </li>
          </ng-container>
        </ol>
      </div>-->

    </div>
  </div>
</div>
<!-- end page title -->
